import { render, staticRenderFns } from "./ListarObrasSociales.vue?vue&type=template&id=45f3c670&"
import script from "./ListarObrasSociales.vue?vue&type=script&lang=js&"
export * from "./ListarObrasSociales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports